
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Cabserviceinpune() {



    const cardData =
    {
        keyword: ' Cab Service in Pune',
        heading: 'Prince Cabs: Cab Service in Pune',
        headingDescription: 'Prince Cabs provides dependable Cab Service in Pune, catering to local travel, airport transfers, corporate rides, family trips, and outstation journeys. Our fleet of well-maintained sedans, SUVs, and luxury cars ensures a safe, comfortable, and affordable ride for every travel need. With professional chauffeurs, flexible booking options, and on-time service, we make city commuting and long-distance travel completely hassle-free. Choose Prince Cabs’ trusted cab service in Pune for reliable, convenient, and budget-friendly travel solutions.',

        top: 'Top Places to Visit in Pune with Prince Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732, Shaniwar Wada was the seat of the mighty Peshwas of the Maratha Empire. Though much of it was destroyed by fire in 1828, the fort remains a symbol of Pune’s rich history. Visitors can explore its grand gates, massive walls, and gardens. The evening light and sound show brings alive tales of Maratha valor. Its legends and architecture make it a cultural icon. It is a must-visit for history lovers in Pune."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, built in 1892, is both an architectural gem and a site of great historical importance. During the Quit India Movement, Mahatma Gandhi, Kasturba Gandhi, and other leaders were imprisoned here. The palace also houses a museum with artifacts and photographs from the freedom struggle. Its sprawling gardens offer a calm retreat within the city. It is a national monument of pride and remembrance. Tourists admire both its beauty and historical depth."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, located about 30 km from Pune, is one of the most famous hill forts in Maharashtra. Known for the Battle of Sinhagad fought in 1670, it has deep connections with Maratha history. The fort offers trekking trails, scenic landscapes, and ancient ruins. Visitors enjoy local delicacies like pithla-bhakri at the top. Its panoramic views of the Sahyadri mountains are breathtaking. It is a favorite for both history buffs and nature lovers."
  },
  {
    "title": "Dagdusheth Halwai Ganapati Temple",
    "description": "The Dagdusheth Halwai Ganapati Temple is one of Pune’s most famous religious landmarks, dedicated to Lord Ganesha. The beautifully adorned idol attracts thousands of devotees daily. During Ganesh Chaturthi, the temple is decorated with grandeur and draws huge crowds. Its central location makes it easily accessible. The temple is also involved in charitable activities, reflecting community values. It stands as a spiritual and cultural landmark of Pune."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Dating back to the 8th century, the Pataleshwar Cave Temple is a rock-cut shrine dedicated to Lord Shiva. It features a large stone linga, carved pillars, and an unfinished mandapa. The temple’s peaceful setting makes it a quiet escape within the city. It reflects Rashtrakuta-era architecture and artistry. Visitors often come here for meditation and photography. It is a hidden gem blending history and spirituality."
  },
  {
    "title": "Parvati Hill and Temples",
    "description": "Parvati Hill is one of Pune’s highest points, offering panoramic views of the city. The hill is home to several ancient temples, including those dedicated to Lord Shiva and Goddess Parvati. The climb of 103 steps is steep but rewarding. The Peshwa Museum at the hilltop adds historical value. Sunrises and sunsets from here are particularly beautiful. It is a serene and spiritual destination in Pune."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This museum houses a vast collection of artifacts, musical instruments, sculptures, and everyday objects from across India. The collection was put together by Dr. Dinkar Kelkar in memory of his son. The museum highlights the artistic and cultural diversity of Maharashtra and India. Its exhibits fascinate both history buffs and art lovers. The three-storey building itself is a heritage structure. It is one of Pune’s most distinctive museums."
  },
  {
    "title": "Osho Ashram (Osho International Meditation Resort)",
    "description": "Located in Koregaon Park, the Osho Ashram is a world-famous spiritual retreat founded by Osho Rajneesh. Visitors from across the globe come here for meditation, yoga, and wellness programs. The ashram is surrounded by lush gardens, marble pathways, and modern facilities. It promotes holistic healing and personal growth. The international community adds a cosmopolitan touch. It is a unique spiritual destination in Pune."
  },
  {
    "title": "Phoenix Marketcity Pune",
    "description": "Phoenix Marketcity is one of the largest malls in Pune, offering a mix of international and local brands. The mall also features entertainment zones, restaurants, and a multiplex. It is a popular hangout for youth and families. Seasonal festivals, events, and live music performances add to the excitement. It combines shopping, dining, and leisure under one roof. It is Pune’s modern lifestyle hub."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Situated about 20 km from Pune, Khadakwasla Dam is a scenic spot surrounded by rolling hills. It creates a vast reservoir that provides water to the city. The dam is especially popular during monsoon when the landscape is lush and vibrant. Families often picnic here to enjoy the cool breeze and natural setting. Street food stalls add local flavor to the visit. It is a refreshing escape from city life."
  },
  {
    "title": "Shreemant Dagdusheth Halwai Ganapati Museum",
    "description": "Located near the temple, this museum showcases the history and traditions associated with Pune’s iconic Ganesh festival. Visitors learn about the cultural and social impact of the Dagdusheth trust. The museum features photographs, decorations, and stories from past celebrations. It is an immersive way to experience Pune’s devotion. The exhibits highlight the community’s unity and spirituality. A must-visit for those curious about Pune’s Ganeshotsav legacy."
  },
  {
    "title": "National War Memorial Southern Command",
    "description": "This memorial honors the sacrifices of Indian soldiers who fought in various wars after Independence. It features war relics, tanks, and weapons displayed for public viewing. The museum inside narrates stories of bravery and valor. Visitors attend the evening ceremony with a flag retreat, which is deeply moving. It instills a sense of patriotism and respect for the armed forces. It is one of Pune’s most inspiring landmarks."
  },
  {
    "title": "Mulshi Lake and Dam",
    "description": "Located about 40 km from Pune, Mulshi Lake is a popular weekend getaway surrounded by Sahyadri hills. The backwaters of the dam create a tranquil environment perfect for boating and camping. During monsoon, waterfalls and greenery make it spectacular. Adventure seekers enjoy trekking and photography in the area. Eco-resorts nearby add comfort to the natural charm. It is a great escape for nature lovers."
  },
  {
    "title": "Chaturshringi Temple",
    "description": "Situated on Senapati Bapat Road, Chaturshringi Temple is one of Pune’s oldest and most revered temples. Dedicated to Goddess Chaturshringi (an incarnation of Goddess Durga), it is located on a hilltop, requiring devotees to climb 100 steps. The temple is especially vibrant during Navratri with grand celebrations. The shrine attracts devotees from across Maharashtra. Its spiritual aura blends with scenic views of the city. It remains an important religious landmark."
  },
  {
    "title": "Empress Garden",
    "description": "Empress Garden is a lush botanical garden maintained by the Agri-Horticultural Society of Western India. Spread across 39 acres, it is home to exotic plant species, flower nurseries, and shaded pathways. Families enjoy picnics here under century-old trees. Seasonal flower shows attract tourists and garden lovers. The garden provides a calm oasis within bustling Pune. It is an ideal destination for nature enthusiasts and children."
  }
],


"services": [
    {
        "name": "Pune Car Rental with Driver",
        "description": "Rent a car with a professional driver in Pune for hassle-free travel across the city or outstation. Whether it's daily commuting, airport transfers, or long-distance trips, enjoy safe, punctual, and comfortable rides with experienced chauffeurs who know the local routes well."
    },
    {
        "name": "Taxi Service in Pune",
        "description": "Our reliable taxi service in Pune offers clean, well-maintained vehicles for all your travel needs. From quick local trips to full-day hires, our taxis are perfect for business meetings, sightseeing, or daily errands, ensuring prompt pickups and courteous drivers."
    },
    {
        "name": "Best Cab Service in Pune",
        "description": "Experience the best cab service in Pune, known for punctuality, professionalism, and customer satisfaction. Choose from a wide range of vehicles, including sedans and SUVs, all equipped with modern amenities for a comfortable journey around the city or beyond."
    },
    {
        "name": "Best Taxi Service in Pune",
        "description": "Get the best taxi service in Pune with reliable drivers, affordable rates, and a fleet of vehicles that cater to solo travelers, families, and corporate clients. Our service promises safety, comfort, and easy booking options via phone or online platforms."
    },
    {
        "name": "Best Cab Service Pune to Mumbai",
        "description": "Travel from Pune to Mumbai with the best cab service offering timely pickups, experienced drivers, and comfortable cars. Ideal for business trips, airport transfers, or weekend getaways, we ensure a smooth and stress-free journey between these two major cities."
    },
    {
        "name": "Innova for Rent in Pune",
        "description": "Rent a Toyota Innova in Pune for spacious and comfortable travel. Perfect for group outings, family trips, or corporate events, our Innova cabs come with professional drivers and all necessary amenities for a pleasant ride across Pune and nearby destinations."
    },
    {
        "name": "Swift Dzire Cab Service for Outstation",
        "description": "Choose Swift Dzire cab service for affordable and comfortable outstation travel from Pune. Whether you’re headed to nearby towns or long-distance destinations, enjoy fuel-efficient rides with clean vehicles and experienced drivers familiar with the best routes."
    },
    {
        "name": "Cab Booking in Pune",
        "description": "Easily book your cab in Pune with our quick and convenient service. Choose your preferred vehicle type, schedule your pickup, and receive instant confirmation. Perfect for last-minute trips or planned travel, our booking system makes city travel simple and efficient."
    },
    {
        "name": "Pune to Jejuri Cab",
        "description": "Plan your pilgrimage or day trip from Pune to Jejuri with our dedicated cab service. Travel comfortably with reliable drivers who understand the route well, and enjoy hassle-free bookings with fixed rates and clean, well-maintained vehicles."
    },
    {
        "name": "Pune to Jejuri Taxi Fare",
        "description": "Check transparent and competitive taxi fares for Pune to Jejuri trips. Our pricing is all-inclusive, covering tolls and driver allowances, with no hidden charges. Get the best value for your money with our affordable yet premium taxi services."
    },
    {
        "name": "Pune to Jejuri Cab Fare",
        "description": "Get detailed cab fare information for Pune to Jejuri travel. Whether you choose one-way or round-trip, sedan or SUV, we provide cost-effective pricing with excellent service quality to ensure a smooth journey for devotees and travelers alike."
    },
    {
        "name": "Pune to Jejuri Cab Service",
        "description": "Our dedicated cab service from Pune to Jejuri is designed to offer comfortable and safe travel for pilgrims and tourists. Choose from various vehicle options, enjoy on-time pickups, and experience professional driving that makes your trip pleasant and memorable."
    },
    {
        "name": "Pune to Jejuri Taxi",
        "description": "Avail reliable taxi service from Pune to Jejuri with flexible booking options. Perfect for religious visits or day trips, our taxis are equipped with modern amenities and driven by courteous drivers ensuring a safe and timely journey."
    },
    {
        "name": "Pune Local Cab Service",
        "description": "For quick and convenient travel within Pune city, use our local cab service. Ideal for office commutes, shopping trips, or short errands, our clean vehicles and professional drivers make city travel stress-free and affordable."
    },
    {
        "name": "Pune to Ketkawale Balaji Temple Cab",
        "description": "Plan your trip to Ketkawale Balaji Temple from Pune with our reliable cab service. Enjoy comfortable rides with experienced drivers familiar with temple routes, ensuring timely arrivals and safe journeys for devotees."
    },
    {
        "name": "Pune Local Taxi Hire",
        "description": "Hire a taxi locally in Pune for hourly or daily use. Perfect for exploring the city or managing multiple appointments in a day, our local taxi hire service offers flexibility, professional drivers, and well-maintained vehicles at competitive rates."
    },
    {
        "name": "Cab Near Pune Station",
        "description": "Need a cab near Pune station? Our prompt pickup service ensures you have a reliable vehicle waiting as soon as you arrive. Avoid waiting times and travel comfortably to your destination with our easily accessible cabs near the railway station."
    },
    {
        "name": "Affordable Cab in Pune",
        "description": "Get affordable cab services across Pune without compromising on safety or comfort. Our competitively priced rides cater to budget-conscious travelers, with transparent pricing and quality vehicles suitable for city and outstation travel."
    },
    {
        "name": "Luxury Cab in Pune",
        "description": "Travel in style with our luxury cab service in Pune, featuring high-end vehicles like Mercedes, Audi, and BMW. Perfect for corporate travel, special occasions, or VIP clients, enjoy premium amenities, expert chauffeurs, and a superior ride experience."
    }
],
"tableData": [
    ["Pune Car Rental with Driver", "Taxi Service in Pune"],
    ["Best Cab Service in Pune", "Best Taxi Service in Pune"],
    ["Best Cab Service Pune to Mumbai", "Innova for Rent in Pune"],
    ["Swift Dzire Cab Service for Outstation", "Cab Booking in Pune"],
    ["Pune to Jejuri Cab", "Pune to Jejuri Taxi Fare"],
    ["Pune to Jejuri Cab Fare", "Pune to Jejuri Cab Service"],
    ["Pune to Jejuri Taxi", "Pune Local Cab Service"],
    ["Pune to Ketkawale Balaji Temple Cab", "Pune Local Taxi Hire"],
    ["Cab Near Pune Station", "Affordable Cab in Pune"],
    ["Luxury Cab in Pune", ""]
],


"whychoose": [
    {
        "WhyChooseheading": "Trusted and Reliable Cab Service in Pune",
        "WhyChoosedescription": "Prince Cabs provides a dependable and professional cab service across Pune, catering to daily commuters, tourists, corporate clients, and families alike. Whether you need airport transfers, city tours, business travel, or last-minute rides, we ensure punctuality, comfort, and a hassle-free booking experience."
    },
    {
        "WhyChooseheading": "Wide Range of Comfortable and Well-Maintained Vehicles",
        "WhyChoosedescription": "Our fleet includes a variety of vehicles such as hatchbacks, sedans, SUVs, and luxury cars like Innova and Crysta, all maintained to the highest standards. Each cab is cleaned regularly, air-conditioned, and equipped with ergonomic seating to provide a comfortable ride within Pune’s city limits and surrounding areas."
    },
    {
        "WhyChooseheading": "Professional and Experienced Drivers",
        "WhyChoosedescription": "We employ skilled and courteous drivers who are knowledgeable about Pune’s traffic patterns, routes, and local landmarks. Our drivers prioritize safety, timely pickups, and smooth rides, ensuring you reach your destination stress-free and on time."
    },
    {
        "WhyChooseheading": "Flexible Booking and Payment Options",
        "WhyChoosedescription": "Prince Cabs offers flexible booking options including hourly rentals, full-day packages, airport transfers, and outstation trips. Booking is easy via phone, website, or WhatsApp, and we accept multiple secure payment methods such as UPI, credit/debit cards, net banking, and cash, providing convenience at every step."
    },
    {
        "WhyChooseheading": "Strict Hygiene and Safety Protocols",
        "WhyChoosedescription": "In response to health concerns, all vehicles are thoroughly sanitized before and after every trip. We follow strict safety protocols and maintain our fleet regularly to ensure your journey is safe, clean, and comfortable at all times."
    },
    {
        "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
        "WhyChoosedescription": "We believe in complete transparency and offer competitive pricing with no hidden fees. You receive a clear fare estimate before booking, helping you plan your travel budget confidently without surprises."
    },
    {
        "WhyChooseheading": "24/7 Customer Support for Seamless Travel",
        "WhyChoosedescription": "Our dedicated customer support team is available around the clock to assist with booking, cancellations, queries, and any assistance you might need during your ride. We strive to make your cab experience in Pune smooth, reliable, and enjoyable."
    }
]





















    }

const faqData = [
    {
        question: 'Does Prince Cabs offer local cab services in Pune?',
        answer: 'Yes, Prince Cabs provides reliable and affordable local cab services across Pune for city travel, shopping, business meetings, and day rentals.',
    },
    {
        question: 'What types of cabs are available with Prince Cabs in Pune?',
        answer: 'We offer hatchbacks, sedans, SUVs, and tempo travellers—perfect for solo rides, family outings, airport transfers, or group travel.',
    },
    {
        question: 'Can I book a cab for hourly or full-day usage in Pune?',
        answer: 'Absolutely! We offer flexible packages including hourly rentals and full-day cab bookings tailored to your schedule and requirements.',
    },
    {
        question: 'Are your Pune cabs suitable for corporate and office travel?',
        answer: 'Yes, we serve several corporate clients with punctual and professional cab services, including regular pickups, drops, and employee transportation.',
    },
    {
        question: 'How affordable is Prince Cabs’ local service in Pune?',
        answer: 'Our pricing is competitive and transparent. Rates vary based on duration, distance, and cab type. Contact us for the best quotes in Pune.',
    },
    {
        question: 'How can I book a cab with Prince Cabs in Pune?',
        answer: 'Booking is easy—just call our helpline or visit our website to book instantly. Our team will help you pick the best cab as per your needs.',
    },
    {
        question: 'Are the cabs sanitized and well-maintained?',
        answer: 'Yes, all our cabs are regularly cleaned, sanitized, and maintained to ensure hygiene and safety for every passenger.',
    },
];

const testimonials = [
    {
        name: "Mr. Ankit Deshmukh",
        position: "IT Professional",
        text: "Prince Cabs is my go-to for daily office travel in Pune. Always on time, clean cars, and polite drivers. Highly recommended!",
        image: "/img/testimonial/testimonial-thumb-pune-1.png",
    },
    {
        name: "Ms. Swati Joshi",
        position: "Local Resident",
        text: "I booked a cab for a full-day Pune city tour. The experience was great—the driver was knowledgeable, and the cab was very comfortable.",
        image: "/img/testimonial/testimonial-thumb-pune-2.png",
    },
];

































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Pune",
  "image": "https://princecab.com/assets/images/pune-cab-service.jpg",
  "description": "Prince Cabs offers the best cab service in Pune with reliable taxi options including Innova, Swift Dzire, and luxury cabs. Book local and outstation taxis with experienced drivers. Available 24/7 for your convenience.",
  "brand": {
    "@type": "Brand",
    "name": "Prince Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "7500"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "600",
    "availability": "https://schema.org/InStock",
    "url": "https://princecab.com/cab-service-in-pune"
  }
};




    return (
        <div>
<Helmet>
  <title>Cab Service in Pune | Reliable & Affordable Taxi Service | Prince Cabs</title>
  <meta
    name="description"
    content="Book cab service in Pune with Prince Cabs. Affordable and reliable taxi options including Innova, Swift Dzire, and luxury cabs for local and outstation travel. 24/7 booking available."
  />
  <meta
    name="keywords"
    content="Pune Car Rental with Driver, Taxi Service in Pune, Best Cab Service in Pune, Best Taxi Service in Pune, Best Cab Service Pune to Mumbai, Innova for Rent in Pune, Swift Dzire Cab Service for Outstation, Cab Booking in Pune, Pune to Jejuri Cab, Pune to Jejuri Taxi Fare, Pune to Jejuri Cab Fare, Pune to Jejuri Cab Service, Pune to Jejuri Taxi, Pune Local Cab Service, Pune to Ketkawale Balaji Temple Cab, Pune Local Taxi Hire, Cab Near Pune Station, Affordable Cab in Pune, Luxury Cab in Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/26.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Cabserviceinpune;